export default function FaqSection() {
  const faqs = [
    {
      q: '69视频是视频播放网站吗？',
      a: '69视频本身不存储或播放任何视频内容。我们是一个视频平台推荐导航站，整理香蕉视频、红桃视频、91视频、蜜桃视频等同类型平台的入口信息和使用指南，帮助用户快速找到适合自己的免费在线视频平台。',
    },
    {
      q: '推荐的平台真的都免费吗？需要注册吗？',
      a: '我们收录的平台以免费在线观看为主，大部分内容无需注册即可播放。部分平台可能对新用户提供免注册体验，长期使用建议注册账号以获得更好的观看记录和个性化推荐功能，但这不是强制要求。',
    },
    {
      q: '在推荐的平台上观看视频安全吗？',
      a: '我们对收录的每一个平台都进行了安全审查，确保页面无恶意弹窗、诱导下载或钓鱼风险。同时建议观众使用主流浏览器访问，并保持浏览器和操作系统的安全更新，以获得最佳防护。',
    },
    {
      q: '为什么不同平台的更新速度不一样？',
      a: '各视频平台的资源来源和更新机制不同，导致同一部剧集在不同平台的上线时间可能存在差异。香蕉视频和红桃视频在剧集同步方面表现较为突出，而91视频和蜜桃视频在特定类型内容上有独到优势。我们建议根据片单需求灵活切换平台。',
    },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">
              常见问题
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              常见问答
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              关于69视频和平台推荐的常见疑问，这里都有答案
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <span className="flex-shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-lg bg-primary-100 text-primary-600 text-sm font-bold">
                    Q
                  </span>
                  <div className="flex-1">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                      {faq.q}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}